<script setup lang="ts">

</script>

<template>
  <div relative w-full overflow-hidden>
    <img src="/images/image-167-btc-1000.webp" h-640px w-full object-cover animated animated-slow style="animation-name: scale-in" alt="1000 BTC Cover">
    <div class="mask" absolute inset-0 />

    <div absolute inset-0 top-100px text-center>
      <p class="lh-100%" text-20px font-bold uppercase animated animated-fade-in-down animated-delay-200>
        YOUR VOTE WILL DETERMINE
      </p>

      <h2 class="lh-100%" mt-20px text-40px font-bold uppercase animated animated-fade-in-down>
        WHO WILL WIN
      </h2>
    </div>

    <div absolute inset-x-0 bottom-0 animated animated-zoom-in>
      <p text-center class="text-[clamp(50px,18vw,80px)] text-#ce0000" font-bold>
        1499 BTC
      </p>
    </div>
  </div>
</template>

<style scoped>
.mask {
  background: linear-gradient(
    180deg,
    rgba(87, 0, 0, 0.77) 0%,
    rgba(102, 0, 0, 0) 22.81%,
    rgba(95, 0, 0, 0) 55.75%,
    #000 94.36%
  );
}
</style>
